import { useTranslation } from "react-i18next";
import { ERROR, IMPORTED, PROCESSING } from "./FuelsConstants";

export const useFuelReportStatuses = () => {
    const {t} = useTranslation(['finance']);

    const getReportStatus = (status: string) => {
        switch (status) {
            case PROCESSING: return t('PROCESSING');
            case IMPORTED: return t('IMPORTED');
            case ERROR: return t('ERROR');
            default : return '-'
        }
    };

    return {
        getReportStatus
    }
}